export default __webpack_public_path__ + "static/cops-flow@2x-08d3b34454d916b98fe250ed5a627f3e.png";